<template>
    <div>
        <BK @click="hy()"></BK>

      <div class="my-team-banner"  style="width: 100%;" v-bind:style="{backgroundImage:'url(' + bg + ')'
   ,backgroundPosition:'center',backgroundRepeat:'no-repeat',backgroundSize: 'cover'}">
        <head-menu   fd="0"  current="5" ></head-menu>
        <img :src="bg" class="my-team-banner-img" style="display:block;width: 100%;position: relative;z-index: -100">

      </div>
      <div style="max-width: 1752px;margin: 0 auto;height: 54px;position: relative;top:-27px;box-shadow:1px 1px 5px 0px rgba(0, 0, 0, 0.2);background-color: #fff">
        <el-menu style="max-width: 1210px;margin:0 auto" :default-active="activeIndex"  mode="horizontal" @select="handleSelect">
          <el-menu-item class="itemx-our-1 ix my-team-tow-list1"  index="1" stlye="margin-left:0px" :class="{xz1:activeIndex==='1'}">基金管理团队</el-menu-item>
          <el-menu-item class="itemx-our-1 my-team-tow-list1" index="2" :class="{xz1:activeIndex==='2'}">基金投资团队</el-menu-item>
          <el-menu-item class="itemx-our-1 my-team-tow-list1" index="3"  :class="{xz1:activeIndex==='3'}">投后管理团队</el-menu-item>
          <el-submenu class="my-team-tow-list" style="float: right">
            <template slot="title">团队</template>
            <el-menu-item @click="handleSelect('1')">基金管理团队</el-menu-item>
            <el-menu-item @click="handleSelect('2')" >基金投资团队</el-menu-item>
            <el-menu-item @click="handleSelect('3')">投后管理团队</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
      <!--<el-row class="show-yitou-head-tlie2">-->
        <!--<el-col :lg="{span:10,offset:0}":md="{span:12,offset:0}" :xs="24" style="margin-top: 30px;margin-bottom: 10px">-->
          <!--<div style="width: 101%;height: 1px;background-color:rgb(229, 229, 229);margin-top: 26px;" ></div>-->
        <!--</el-col>-->
        <!--<el-col :lg="{span:14,offset:0}":md="{span:12,offset:0}" :xs="24" style="margin-top: 30px;margin-bottom: 10px" >-->
          <!--<h3 style="font-weight: bold;border-bottom:1px solid #e5e5e5;padding-bottom: 10px;font-size: 40px;width: 93%;margin-left: 7%">-->
            <!--<span style="border-bottom: 2px solid #083A6F;padding-bottom: 10px">Our Team</span>-->
          <!--</h3>-->
          <!--<div  style="font-size:30px;color:rgba(8,58,111,1);margin-top: 10px;text-align: left;width: 93%;margin-left:7%">&nbsp;&nbsp;&nbsp;道远团队</div>-->
        <!--</el-col>-->
      <!--</el-row>-->
      <!--<div style="text-align:center;font-weight: bold;padding-bottom: 10px;font-size: 2em" class="show-yitou-head-tlie"> </div>-->
      <!--<div class="show-yitou-head-tlie"  style="text-align:center;font-weight: bold;padding-bottom: 10px;font-size: 2em;border-bottom:1px solid #e5e5e5">Our Team</div>-->
      <!--<div class="show-yitou-head-tlie"  style="font-size:22px;color:rgba(8,58,111,1);margin-top: 10px;text-align: center;">道远团队</div>-->
         <div class="my-team-tile">基金管理团队</div>
      <div style="width:35px;height:4px;background:rgba(8,58,111,1);margin: 0 auto;margin-top: 20px"></div>
      <!--<div class="my-team-nr my-team-showx" style="margin-top: 30px">-->
      <div class="my-team-nr my-team-showx" style="margin-top: 30px">
        <el-row  style="padding:18px 0;">
          <el-col :lg="{span:4,offset:2}" :sm="{span:4,offset:2}" :md="{span:4,offset:2}" :xs="{span:24,offset:0}" stlye="text-align: justify">
            <img style="width:100%; display:block;" :src="imgList[0]" >
          </el-col>
          <el-col :lg="{span:15,offset:2}" :sm="{span:15,offset:2}" :md="{span:15,offset:2}" :xs="23" stlye="text-align: justify">
            <div style="height:21px;margin-top: 20px">
              <div class="my-team-text-one">章达峰</div>
              <div class="my-team-text-tow"></div>
            </div>
            <div class="my-team-text-three">
              <span>
                <span style="color:rgba(8,58,111,1)">◆</span>道远资本创始人，美国加利福尼亚大学伯克利分校MBA，清华大学五道口金融学院EMBA，从事股权投资工作超过15年。<br>
 <span style="color:rgba(8,58,111,1)">◆</span>2014创立道远资本，取得了一系列优秀的投资业绩：所投项目中，2019年已经上市的公司包括赛诺医疗（科创板，688108）、锦欣生殖（港股主板，HK1951）、维亚生物（港股主板，HK1873）、博瑞医药（科创板，688166）、硕世生物（科创板，688399）；2020年截至到5月份已有两项目申报IPO（已受理）
                ，2020年预计还有3到4个项目申报IPO；2021年有5到6个项目申报IPO。<br>
<span style="color:rgba(8,58,111,1)">◆</span>在创立道远资本之前，章达峰先生曾任职华润金融控股董事，负责华润产业基金的组建和投资，同时参与牵头华润银行、华润信托、华润基金、华润保险经纪等各业务板块的协同创新。
                其中，参与负责组建的华润城市交通基础设施基金融资2.65亿美元，获得《亚洲资产管理》杂志2013年度“最佳创新奖”。<br>
<span style="color:rgba(8,58,111,1)">◆</span>在此之前，曾任鼎晖创投执行董事、美国艾威资本集团（Avenue Capital Group）董事，主导或参与投资了一系列优秀的项目，其中已经上市或并购退出的公司包括：绿地控股（上交所主板）、21世纪不动产（纳斯达克）、安博教育（纳斯达克）、红黄蓝（纳斯达克）、Gnet（并购退出）等。<br>
 <span style="color:rgba(8,58,111,1)">◆</span>章达峰先生非常强调团队的专业、专长和专注，道远资本云集了一批来自于生物医药、医疗器械、医疗服务和金融财务等方面的优秀人才，他们都受到过国内外最好大学的药学、生物或金融专业的博士或硕士教育，又拥有国内外大药企、器械公司或投资机构从业经验，并且在道远经过多年磨合，形成一支业界领先的医疗大健康投资专业团队。

                <span><br><br><br></span>
              </span>
            </div>
          </el-col>
        </el-row>
        <div>
        </div>
      </div>
      <div class="my-team-nr my-team-showx">
       <el-row  style="padding:18px 0;">
          <el-col :lg="{span:4,offset:2}" :sm="{span:4,offset:2}" :md="{span:4,offset:2}" :xs="{span:24,offset:0}" stlye="text-align: justify">
            <img style="width:100%; display:block;" :src="imgList[1]" >
          </el-col>
          <el-col :lg="{span:15,offset:2}" :sm="{span:15,offset:2}" :md="{span:15,offset:2}" :xs="23" stlye="text-align: justify">
            <div style="height:21px;margin-top: 20px">
              <div class="my-team-text-one">曾&nbsp&nbsp&nbsp萍</div>
              <div class="my-team-text-tow"></div>
            </div>
            <div class="my-team-text-three">
              <span><span style="color:rgba(8,58,111,1)">◆</span>道远资本合伙人，具有12年医疗健康领域股权投资经验、5年医疗器械企业运营管理经验。<br>
 <span style="color:rgba(8,58,111,1)">◆</span>负责道远资本医疗服务和医疗器械领域的投资及投后管理业务，对这两个子行业有深刻的认识理解并建立了独到的投资分析和决策逻辑，在项目的尽职调查和投资判断方面专业严谨并具有独特的经验心得和关注视角，使得投资项目获得了极高的成功率。
<br> <span style="color:rgba(8,58,111,1)">◆</span>曾经主导和参与的多个医疗健康投资项目已成功上市或正在筹备IPO，包括赛诺医疗（688108.SH）、安杰思医学、普瑞眼科、倍肯科技、杭州牙科集团等。
    <br> <span style="color:rgba(8,58,111,1)">◆</span>曾任职于美国艾威资本医疗投资团队，投资的明星项目包括维亚生物（港股，01873.HK）和康龙化成（创业板，300759.SZ）
                 <br> <span style="color:rgba(8,58,111,1)">◆</span>曾在医疗器械企业负责管理产品的注册和市场、销售工作。
                  <br><span style="color:rgba(8,58,111,1)">◆</span>对外经济贸易大学金融学硕士学位。
                <span><br><br><br></span>
                            </span>
            </div>
          </el-col>
        </el-row>
        <div>
        </div>
      </div>

      <div class="my-team-nr my-team-showx">
       <el-row  style="padding:18px 0;">
          <el-col :lg="{span:4,offset:2}" :sm="{span:4,offset:2}" :md="{span:4,offset:2}" :xs="{span:24,offset:0}" stlye="text-align: justify">
            <img style="width:100%; display:block;" :src="imgList[3]" >
          </el-col>
          <el-col :lg="{span:15,offset:2}" :sm="{span:15,offset:2}" :md="{span:15,offset:2}" :xs="23" stlye="text-align: justify">
            <div style="height:21px;margin-top: 20px">
              <div class="my-team-text-one">张雪娟</div>
              <div class="my-team-text-tow"></div>
            </div>
            <div class="my-team-text-three">
              <span> <span style="color:rgba(8,58,111,1)">◆</span>道远资本财务总监。近20年财务管理与财税咨询经验，长期服务于股权投资与投资管理专业机构。<br>
 <span style="color:rgba(8,58,111,1)">◆</span>在投资管理机构资金运营、内控与税务筹划，项目评估、风险防范方面有丰富经验。<br>
 <span style="color:rgba(8,58,111,1)">◆</span>熟悉基金的募集和退出程序，有长期和银行、税务、政府、工商、律师、会计师等交往的经历。</span>
            </div>
          </el-col>
        </el-row>
        <div>
        </div>
      </div>
      <div class="my-team-tile">基金投资团队</div>
      <div style="width:35px;height:4px;background:rgba(8,58,111,1);margin: 0 auto;margin-top: 20px"></div>
      <div class="my-team-nr my-team-showx" style="margin-top: 30px">
       <el-row  style="padding:18px 0;">
          <el-col :lg="{span:4,offset:2}" :sm="{span:4,offset:2}" :md="{span:4,offset:2}" :xs="{span:24,offset:0}" stlye="text-align: justify">
            <img style="width:100%; display:block;" :src="imgList[4]" >
          </el-col>
          <el-col :lg="{span:15,offset:2}" :sm="{span:15,offset:2}" :md="{span:15,offset:2}" :xs="23" stlye="text-align: justify">
            <div style="height:21px;margin-top: 20px">
              <div class="my-team-text-one">康良金</div>
              <div class="my-team-text-tow"></div>
            </div>
            <div class="my-team-text-three">
              <span>
                 <span style="color:rgba(8,58,111,1)">◆</span>主要关注医疗器械、医疗服务领域投资机会。曾任职费森尤斯和华润医药集团，作为核心成员参与药品和器械项目的投资并购，并成功退出；八年医疗行业经验，业内资源丰富。<br>
 <span style="color:rgba(8,58,111,1)">◆</span>已投资赛诺医疗、安杰思医学、倍肯恒业、美益达医疗等项目。<br><span style="color:rgba(8,58,111,1)">◆</span>吉林大学本科，MBA。
                            </span>
            </div>
          </el-col>
        </el-row>
        <div>
        </div>
      </div>

      <div class="my-team-nr my-team-showx">
       <el-row  style="padding:18px 0;">
          <el-col :lg="{span:4,offset:2}" :sm="{span:4,offset:2}" :md="{span:4,offset:2}" :xs="{span:24,offset:0}" stlye="text-align: justify">
            <img style="width:100%; display:block;" :src="imgList[5]" >
          </el-col>
          <el-col :lg="{span:15,offset:2}" :sm="{span:15,offset:2}" :md="{span:15,offset:2}" :xs="23" stlye="text-align: justify">
            <div style="height:21px;margin-top: 20px">
              <div class="my-team-text-one">刘侃侃</div>
              <div class="my-team-text-tow"></div>
            </div>
            <div class="my-team-text-three">
              <span> <span style="color:rgba(8,58,111,1)">◆</span>主要关注制药领域的投资机会，对医药行业的全产业链有着深刻的理解。曾就职于上市公司东诚药业（002675），
                担任投资并购经理，主导或参与制药领域战略规划及产业并购；此前还拥有2年的制药企业研发BD经验。<br>
 <span style="color:rgba(8,58,111,1)">◆</span>加入道远资本以来，涉及的投资标的涵盖早期生物技术公司、创新药公司以及大型制药企业。投资案例包括倍特药业、 三叶草生物、 普众发现等项目。<br>
 <span style="color:rgba(8,58,111,1)">◆</span>南开大学药物化学硕士学位和中国药科大学学士学位。

                <span><br><br></span>
                            </span>
            </div>
          </el-col>
        </el-row>
        <div>
        </div>
      </div>

      <div class="my-team-nr my-team-showx">
       <el-row  style="padding:18px 0;">
          <el-col :lg="{span:4,offset:2}" :sm="{span:4,offset:2}" :md="{span:4,offset:2}" :xs="{span:24,offset:0}" stlye="text-align: justify">
            <img style="width:100%; display:block;" :src="imgList[6]" >
          </el-col>
          <el-col :lg="{span:15,offset:2}" :sm="{span:15,offset:2}" :md="{span:15,offset:2}" :xs="23" stlye="text-align: justify">
            <div style="height:21px;margin-top: 20px">
              <div class="my-team-text-one">衣丽婷</div>
              <div class="my-team-text-tow"></div>
            </div>
            <div class="my-team-text-three">
              <span>
               <span style="color:rgba(8,58,111,1)">◆</span>主要关注创新药领域的投资机会，注重技术驱动和长线发展。<br>
 <span style="color:rgba(8,58,111,1)">◆</span>曾就职于上市公司下属的股权投资机构，之后在大型生物技术公司负责战略投资。<br>
 <span style="color:rgba(8,58,111,1)">◆</span>曾主导多个医疗健康项目的投资，包括细胞治疗，小分子药和医疗器械等。<br>
 <span style="color:rgba(8,58,111,1)">◆</span>作为第一作者发表多篇国际核心期刊论文，作为主要作者在Springer出版社出版英文书籍一部。<br>
 <span style="color:rgba(8,58,111,1)">◆</span>中国科学院博士后，清华大学生物医学工程博士，吉林大学生物工程本科。
              </span>
            </div>
          </el-col>
        </el-row>
        <div>
        </div>
      </div>

      <div class="my-team-nr my-team-showx">
       <el-row  style="padding:18px 0;">
          <el-col :lg="{span:4,offset:2}" :sm="{span:4,offset:2}" :md="{span:4,offset:2}" :xs="{span:24,offset:0}" stlye="text-align: justify">
            <img style="width:100%; display:block;" :src="imgList[7]" >
          </el-col>
          <el-col :lg="{span:15,offset:2}" :sm="{span:15,offset:2}" :md="{span:15,offset:2}" :xs="23" stlye="text-align: justify">
            <div style="height:21px;margin-top: 20px">
              <div class="my-team-text-one">刘金姣</div>
              <div class="my-team-text-tow"></div>
            </div>
            <div class="my-team-text-three">
              <span> <span style="color:rgba(8,58,111,1)">◆</span>主要关注体外诊断和创新医疗器械的投资机会。具有多年医疗领域VC投资经验，参与多起早期项目投资及投后管理 。<br>
 <span style="color:rgba(8,58,111,1)">◆</span>北京大学基础医学院学士、硕士学位，在Cell Research/Shock/BBRC等杂志以第一作者或主要参与者发表论文。<br>
                            </span>
            </div>
          </el-col>
        </el-row>
        <div>
        </div>
      </div>
      <div class="my-team-tile">投后管理团队</div>
      <div style="width:35px;height:4px;background:rgba(8,58,111,1);margin: 0 auto;margin-top: 20px"></div>
      <div class="my-team-nr my-team-showx" style="margin-top: 30px">
        <el-row  style="padding: 18px 0px;">
          <el-col :lg="{span:4,offset:2}" :sm="{span:4,offset:2}" :md="{span:4,offset:2}" :xs="{span:24,offset:0}" stlye="text-align: justify">
            <img style="width:100%; display:block;" :src="imgList[8]" >
          </el-col>
          <el-col :lg="{span:15,offset:2}" :sm="{span:15,offset:2}" :md="{span:15,offset:2}" :xs="23" stlye="text-align: justify">
            <div style="height:21px;margin-top: 20px">
              <div class="my-team-text-one">林&nbsp&nbsp&nbsp铮</div>
              <div class="my-team-text-tow"></div>
            </div>
            <div class="my-team-text-three">
              <span> <span style="color:rgba(8,58,111,1)">◆</span>道远资本投后管理经理。主要负责公司已投项目的投后管理工作，并对项目进行系统的评估。<br>
 <span style="color:rgba(8,58,111,1)">◆</span>具有多年的投资项目管理、投资银行以及财富管理工作经验，熟悉募资、投研、一级市场投资、二级市场投行服务、上市公司再融资相关的各个环节。<br>
 <span style="color:rgba(8,58,111,1)">◆</span>曾任职于中信证券、诺亚财富、Alliance International Capital等公司。<br>
                 <span style="color:rgba(8,58,111,1)">◆</span>英国赫特福德大学管理学硕士。
              </span>

            </div>
          </el-col>
        </el-row>
        <div>
        </div>
      </div>

      <div class="my-team-nr my-team-showx">
       <el-row  style="padding:18px 0;">
          <el-col :lg="{span:4,offset:2}" :sm="{span:4,offset:2}" :md="{span:4,offset:2}" :xs="{span:24,offset:0}" stlye="text-align: justify">
            <img style="width:100%; display:block;" :src="imgList[9]" >
          </el-col>
          <el-col :lg="{span:15,offset:2}" :sm="{span:15,offset:2}" :md="{span:15,offset:2}" :xs="23" stlye="text-align: justify">
            <div style="height:21px;margin-top: 20px">
              <div class="my-team-text-one">黄&nbsp&nbsp&nbsp玮</div>
              <div class="my-team-text-tow"></div>
            </div>
            <div class="my-team-text-three">
              <span> <span style="color:rgba(8,58,111,1)">◆</span>道远资本财务经理，中级会计师，从业8年，先后任职于国内知名医药研发，生产，销售公司，对医药行业财务制度，内控，流程及涉税内容有着深入了解。<br>
 <span style="color:rgba(8,58,111,1)">◆</span>加入道远资本后，主要负责管理公司及旗下各基金财务运行，税务筹划，产品的设立及备案等工作内容。</span>
            </div>
          </el-col>
        </el-row>
        <div>
        </div>
      </div>

      <div class="my-team-nr my-team-showx">
       <el-row  style="padding:18px 0;">
          <el-col :lg="{span:4,offset:2}" :sm="{span:4,offset:2}" :md="{span:4,offset:2}" :xs="{span:24,offset:0}" stlye="text-align: justify">
            <img style="width:100%; display:block;" :src="imgList[10]" >
          </el-col>
          <el-col :lg="{span:15,offset:2}" :sm="{span:15,offset:2}" :md="{span:15,offset:2}" :xs="23" stlye="text-align: justify">
            <div style="height:21px;margin-top: 20px">
              <div class="my-team-text-one">郭智颖</div>
              <div class="my-team-text-tow"></div>
            </div>
            <div class="my-team-text-three">
              <span>
                 <span style="color:rgba(8,58,111,1)">◆</span>主要从事公司的投后项目管理工作，负责联络项目方和投资人，并参与评估项目的进展情况和潜在风险情况。<br>
                <span style="color:rgba(8,58,111,1)">◆</span> 澳大利亚悉尼大学会计学硕士学位。
                            </span>
            </div>
          </el-col>
        </el-row>
        <div>
        </div>
      </div>
      <div style="height: 100px"></div>
      <footee></footee>

    </div>

</template>

<script>
  import HeadMenu from '../../share/head-mean'
  import footee from '../../share/footer.vue'
  import BK from '../../share/fh.vue'
  export default {
    components:{
      "head-menu":HeadMenu,
      "footee":footee,
      "BK":BK
    },
    name: "myTeam",
    data(){
      return {
        bg: require('@/assets/myteam/6.jpg'),
        activeIndex:'1',
        imgList:[
          require('@/assets/myteam/zdf.png'),
          require('@/assets/myteam/zp1.png'),
          require('@/assets/myteam/fjw.png'),
          require('@/assets/myteam/zxj.png'),
          require('@/assets/myteam/glj.png'),
          require('@/assets/myteam/ltt.png'),
          require('@/assets/myteam/ylt.jpg'),
          require('@/assets/myteam/ljj.png'),
          require('@/assets/myteam/lz.png'),
          require('@/assets/myteam/hw.png'),
          require('@/assets/myteam/gzy.png')
        ],
        isThisIe:false
      }
    },created() {
      if (!!window.ActiveXObject || "ActiveXObject" in window)
      {
        this.isThisIe=true
      }
      else {
        this.isThisIe=false
      }
    }
    ,methods:{
      handleSelect(key, keyPath) {
        console.log(key)
        this.activeIndex=key
        var el=document.getElementsByClassName(`my-team-tile`)[Number(key)-1];
        this.$nextTick(function () {
          if(this.isThisIe){
            console.log("测试")
          }else{
            window.scrollTo({"behavior":"smooth","top":el.offsetTop});
          }
        })
      },hy() {
        this.activeIndex='1'
      }
    }
  }
</script>

<style scoped>
.itemx-our-1{
  height: 54px !important;
  line-height: 54px !important;
  margin-top: 0px !important;
}
.ix{
   margin-left: 0px!important;
}
.xz1{
  border-bottom: 2px solid #083A6F !important;
}
.my-team-nr{
  max-width: 1210px;
  background:rgba(248,248,250,1);
  margin: 0 auto;
  margin-top:100px;
  border-bottom: 2px solid rgba(102,100,100,1);
}
@media screen and (min-width: 1210px){
  .my-team-banner{
   height: 400px;
  }
  .my-team-banner-img{
    display: none !important;
  }
  .show-yitou-head-tlie{
    display: none;
  }
}
@media screen and (min-width: 750px){
  .my-team-tow-list{
    display:none;
  }

}
@media screen and (max-width: 1210px){
  .show-yitou-head-tlie2{
    display: none;
  }
}
@media screen and (max-width: 750px){

  .my-team-tow-list1{
    display:none;
  }
  .my-team-text-three{
    margin-left: 10px;
  }
  .my-team-text-tow{
    margin-left: 10px;
  }
  .my-team-text-one{
    margin-left: 10px;
  }
}
.my-team-nr:hover{
  box-shadow:5px 8px 10px 0px rgba(188,188,188,0.53), -4px -8px 10px 0px rgba(188,188,188,0.15);
  border-bottom: 2px solid rgba(8,58,111,1);
  background-color: #fff;
}
.my-team-text-one{
  font-size:1.7em;
  line-height:20px;
  font-weight:400;
  color:rgba(8,58,111,1);
  float: left;
}
.my-team-text-tow{
   font-size:1em;
   font-weight:400;
   color:rgba(152,152,152,1);
   float: right;
   line-height: 29px;
 }
.my-team-text-three{
  margin-top: 45px;
  color:rgba(152,152,152,1);
  line-height:2em;
  font-size: 0.9em;
}
.my-team-tile{
  font-family:Microsoft YaHei;
  margin-top: 35px;
  text-align: center;
  font-size:30px;
  font-weight:400;
}
  /deep/ .el-menu-item{
    padding: 0px;
  }
/deep/ .el-menu--horizontal>.el-menu-item.is-active{
  font-weight:bold;
  color:rgba(8,58,111,1);
  border-bottom: 0px;
}

</style>



// WEBPACK FOOTER //
// src/components/myTeam/indexEN.vue